import { DISPLAY_STATE } from '@/types'

import type { ScoreBugPosition } from '@/services/jsonDataService'
import type { CSSProperties } from 'react'

interface HorizontalBannerPlacement {
  wrapperClass: string
  wrapperStyle?: CSSProperties
}

/**
 * Returns the CSS class and any inline style for the horizontal banner wrapper.
 *
 *   SCOREBAR          → always bottom-centred above the bar, offset by measured bar height
 *   bottom (centred)  → centred above the scorebug; offset by measured scorebug height
 *   bottom-left       → bottom-right corner (opposite side to scorebug)
 *   bottom-right      → bottom-left corner (opposite side to scorebug)
 *   top / top-*       → bottom-centred with 2rem from the bottom edge
 *
 * panelHeight is the live height of the active panel element in px.
 */
export const getHorizontalBannerPlacement = (
  scoreBugPosition: ScoreBugPosition,
  panelHeight = 0,
  displayState?: DISPLAY_STATE
): HorizontalBannerPlacement => {
  // Scorebar and Intro are always bottom-centred; banner sits above them regardless of scoreBugPosition
  if (displayState === DISPLAY_STATE.SCOREBAR || displayState === DISPLAY_STATE.INTRO) {
    return {
      wrapperClass: 'sponsor-banner--horizontal-centre',
      wrapperStyle: panelHeight > 0 ? { bottom: `calc(2rem + ${panelHeight}px)` } : undefined,
    }
  }

  switch (scoreBugPosition) {
    case 'bottom-left':
      return { wrapperClass: 'sponsor-banner--horizontal-right' }
    case 'bottom-right':
      return { wrapperClass: 'sponsor-banner--horizontal-left' }
    case 'bottom':
      return {
        wrapperClass: 'sponsor-banner--horizontal-centre',
        wrapperStyle: panelHeight > 0 ? { bottom: `calc(2rem + ${panelHeight}px)` } : undefined,
      }
    default:
      // top, top-left, top-right — scorebug is out of the way, sit 2rem from the bottom
      return {
        wrapperClass: 'sponsor-banner--horizontal-centre',
        wrapperStyle: { bottom: '2rem' },
      }
  }
}
